import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorNotificationService {

  private NotificationSubject = new BehaviorSubject<string>('');
  public errorNotification$ = this.NotificationSubject.asObservable();

  constructor() { }

  notify(message: string) {
    this.NotificationSubject.next(message);
  }

  getErrorMessage() :string{
    return this.NotificationSubject.value;
  }
}
